export interface Article {
  id: number;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  image: string;
  date: string;
  views: number;
  tags: string[];
  author: string;
  featured: boolean;
  trending: boolean;
}

export const articles: Article[] = [
  {
    id: 1,
    title: '某顶流男星被曝深夜密会神秘女子，酒店共度8小时',
    slug: 'dingliu-nanxing-mi-hui-nuzi',
    excerpt: '据知情人士爆料，某自称单身的顶流男星在横店拍戏期间，深夜与一名神秘女子在酒店共度8小时。该女子被拍到次日清晨才离开酒店，全程口罩墨镜全副武装。',
    content: `<p>近日，娱乐圈再爆重磅消息。据知情人士向本平台独家爆料，某位长期以"单身"人设示人的顶流男星，在横店拍摄新剧期间，深夜密会一名神秘女子。</p>
    <p>据目击者称，当晚约11点，该男星结束一天拍摄后返回酒店。约半小时后，一名身穿黑色长裙的女子从酒店后门进入，径直前往该男星所在楼层。直到次日早上7点，该女子才从酒店离开，全程戴着口罩和墨镜，显得极为谨慎。</p>
    <p>值得注意的是，该男星此前在多个综艺节目中强调自己"单身多年，专注事业"，其粉丝群体也一直以"事业型偶像"为其打造人设。如果此次爆料属实，无疑将对其公众形象造成重大打击。</p>
    <p>业内人士分析，该男星近期有多部作品待播，代言合同也在洽谈中。如果恋情曝光导致"塌房"，可能面临高达数千万的违约金赔偿。</p>
    <p>目前，该男星工作室尚未对此事作出回应。本平台将持续关注事件进展。</p>`,
    category: '明星爆料',
    categorySlug: 'mingxing-baoliao',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20night%20scene%20of%20a%20luxury%20hotel%20entrance%20with%20paparazzi%20flash%20lights%2C%20mysterious%20silhouette%20figure%20walking%20out%2C%20cinematic%20noir%20lighting%2C%20warm%20golden%20and%20deep%20red%20tones%2C%20editorial%20photography%20style%20with%20dramatic%20shadows%2C%20entertainment%20news%20atmosphere&width=800&height=500&seq=article-1-2026&orientation=landscape',
    date: '2026-08-06',
    views: 128500,
    tags: ['顶流塌房', '恋情曝光', '人设崩塌'],
    author: '黑料编辑部',
    featured: true,
    trending: true,
  },
  {
    id: 2,
    title: '知名女星偷税漏税被罚2.8亿，工作室连夜发道歉声明',
    slug: 'zhiming-nvxing-toushui-beifa',
    excerpt: '国家税务总局通报，某知名女星因偷逃税款被追缴并处罚款共计2.8亿元。该女星工作室连夜发布道歉声明，称将积极配合整改。',
    content: `<p>国家税务总局今日发布通报，某知名女演员因通过拆分合同、虚假申报等方式偷逃个人所得税，被依法追缴税款、加收滞纳金并处罚款，共计2.8亿元。</p>
    <p>通报显示，该女星在2019年至2025年期间，通过将其个人劳务报酬转换为企业收入进行虚假申报，偷逃个人所得税超过1.2亿元。税务部门在掌握充分证据后，依法对其作出处理决定。</p>
    <p>消息公布后，该女星工作室连夜发布道歉声明："对于税务问题，我们深感愧疚和自责。完全接受税务部门的处罚决定，将按期缴纳税款、滞纳金和罚款。同时向公众真诚道歉。"</p>
    <p>受此事件影响，该女星参演的多部影视作品面临下架风险，多家品牌方已紧急宣布解约。据业内人士估算，此次事件给该女星造成的直接和间接损失可能超过5亿元。</p>
    <p>近年来，娱乐圈偷税漏税事件频发，引发社会广泛关注。税务部门表示将持续加强对高收入人群的税收监管。</p>`,
    category: '最新丑闻',
    categorySlug: 'zuixin-chouwen',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20scene%20of%20financial%20documents%20and%20tax%20forms%20scattered%20on%20a%20dark%20desk%2C%20red%20stamp%20marks%2C%20cinematic%20lighting%20with%20warm%20amber%20and%20deep%20crimson%20tones%2C%20investigative%20journalism%20aesthetic%2C%20moody%20atmosphere%20with%20soft%20shadows&width=800&height=500&seq=article-2-2026&orientation=landscape',
    date: '2026-08-05',
    views: 256300,
    tags: ['偷税漏税', '人设崩塌'],
    author: '黑料编辑部',
    featured: true,
    trending: true,
  },
  {
    id: 3,
    title: '热门选秀节目被曝内定冠军，制作人私下收受巨额贿赂',
    slug: 'xuanxiu-jie-mu-neiding',
    excerpt: '某热门选秀节目被内部工作人员爆料，冠军人选早在节目录制前就已内定。节目制作人被指私下收受参赛选手经纪公司巨额贿赂，操控比赛结果。',
    content: `<p>近日，一档正在热播的选秀节目陷入"内定门"风波。一名自称是该节目组前工作人员的匿名人士向本平台爆料，节目冠军早在海选阶段就已内定，整个比赛过程不过是一场精心编排的表演。</p>
    <p>据爆料人称，某参赛选手的经纪公司在节目录制前向制作人支付了高达2000万元的"打点费"，以确保该选手能够顺利夺得冠军。制作人通过操控评委打分、剪辑导向以及观众投票数据等多种手段，为该选手铺平了夺冠之路。</p>
    <p>"每期节目的排名都是提前定好的，评委的点评也是按照剧本来的，"该爆料人表示，"那些被淘汰的选手，其实早在录制前就知道自己走不到最后，但他们签了保密协议，不敢说。"</p>
    <p>此消息一出，立即引发网友热议。不少观众表示，回看之前的节目，确实能发现一些"剧本痕迹"。截至目前，该节目组和制作人均未对此事作出回应。</p>
    <p>业内人士指出，选秀节目内定现象并非个例，但如此明目张胆的金钱交易仍属罕见。如果爆料属实，相关责任人可能面临商业贿赂的法律指控。</p>`,
    category: '综艺内幕',
    categorySlug: 'zongyi-neimu',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20stage%20scene%20with%20spotlights%20and%20a%20single%20performer%20silhouette%2C%20dark%20backstage%20area%20with%20mysterious%20figures%20exchanging%20envelopes%2C%20cinematic%20lighting%20with%20warm%20spotlight%20and%20deep%20shadows%2C%20entertainment%20industry%20corruption%20theme%2C%20dramatic%20contrast&width=800&height=500&seq=article-3-2026&orientation=landscape',
    date: '2026-08-04',
    views: 189200,
    tags: ['综艺黑幕', '选秀内定'],
    author: '黑料编辑部',
    featured: false,
    trending: true,
  },
  {
    id: 4,
    title: '当红小花片场耍大牌，迟到6小时还要求全组等她补妆',
    slug: 'danghong-xiaohua-shua-dapai',
    excerpt: '某古装剧组工作人员爆料，一位当红小花旦在片场屡次耍大牌，不仅迟到6小时，还要求全剧组等她做完造型才开拍，导致剧组每天损失数十万。',
    content: `<p>近日，某正在横店拍摄的古装剧剧组曝出演职人员矛盾。据剧组工作人员匿名爆料，该剧女一号——一位近年来凭借多部热播剧走红的小花旦，在片场表现极其不专业。</p>
    <p>"她几乎每天都迟到，最短也要晚2个小时，最夸张的一次迟到了6个小时，"该工作人员表示，"整个剧组几百号人就干等着，导演催了几次她都不当回事。"</p>
    <p>更令剧组头疼的是，该女星对自己的造型要求极为苛刻。"每场戏开拍前都要重新补妆、整理发型，至少半小时起步。有一场夜戏，全组在寒风中等到凌晨2点，就因为她对眉毛不满意要重画。"</p>
    <p>据了解，该剧组的日租金、人员工资等开销约30万元。按照该女星平均每天浪费3-4小时计算，剧组每天因此多支出数万元。制作方虽多次沟通，但效果甚微。</p>
    <p>此消息曝光后，该女星粉丝纷纷为其辩护，称"演员对形象有要求是敬业的表现"。但更多网友认为，无故迟到是对整个剧组的不尊重。</p>`,
    category: '圈内黑料',
    categorySlug: 'quannei-heiliao',
    image: 'https://readdy.ai/api/search-image?query=A%20film%20set%20with%20empty%20director%20chair%20and%20waiting%20crew%20members%2C%20dramatic%20lighting%20rig%20hanging%20above%2C%20clock%20showing%20late%20hour%2C%20frustrated%20atmosphere%2C%20cinematic%20warm%20amber%20lighting%20with%20deep%20shadows%2C%20behind%20the%20scenes%20movie%20production%20aesthetic&width=800&height=500&seq=article-4-2026&orientation=landscape',
    date: '2026-08-03',
    views: 98700,
    tags: ['耍大牌', '圈内黑料', '片场八卦'],
    author: '黑料编辑部',
    featured: false,
    trending: false,
  },
  {
    id: 5,
    title: '知名导演被多名女演员实名举报性骚扰，圈内震动',
    slug: 'zhiming-daoyan-xingsaorao',
    excerpt: '三位女演员联合实名举报某知名导演在拍摄期间多次实施性骚扰行为，包括不当言语骚扰和肢体接触。该导演曾执导多部票房过亿的电影。',
    content: `<p>娱乐圈再曝惊人丑闻。今日，三位女演员通过律师联合发布声明，实名举报某知名导演在合作期间多次实施性骚扰行为。</p>
    <p>据举报内容显示，该导演在2018年至2025年期间，利用职务之便，在选角、拍摄过程中对多名女演员进行言语骚扰和不必要的肢体接触。三位举报人提供了详细的聊天记录和时间线作为证据。</p>
    <p>"他以'试戏'为名，要求女演员在酒店房间进行一对一表演，期间多次试图进行肢体接触，"其中一位举报人表示，"当我们拒绝后，他就以'不适合角色'为由将我们换掉。"</p>
    <p>该导演曾执导多部票房过亿的影片，在业内享有较高声誉。消息公布后，多家影视公司紧急发布声明，暂停与该导演的所有合作项目。</p>
    <p>法律专家表示，如果举报内容属实，该导演的行为可能构成强制猥亵罪，面临刑事处罚。目前，警方已介入调查。</p>`,
    category: '最新丑闻',
    categorySlug: 'zuixin-chouwen',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20director%20chair%20on%20an%20empty%20film%20set%2C%20symbolic%20imagery%20of%20power%20abuse%2C%20broken%20spotlight%2C%20dramatic%20crimson%20and%20black%20color%20palette%2C%20cinematic%20noir%20style%2C%20powerful%20visual%20metaphor%20for%20harassment%20in%20entertainment%20industry&width=800&height=500&seq=article-5-2026&orientation=landscape',
    date: '2026-08-02',
    views: 312000,
    tags: ['性骚扰', '潜规则', '圈内黑料'],
    author: '黑料编辑部',
    featured: true,
    trending: true,
  },
  {
    id: 6,
    title: '某男团成员私下恋爱被拍，粉丝后援会集体脱粉',
    slug: 'nantuan-chengyuan-lianai-tuofen',
    excerpt: '某当红男团成员被拍到与圈外女友甜蜜约会，照片曝光后粉丝后援会宣布集体脱粉。该成员此前一直营销"单身敬业"人设，被打脸后引发大面积脱粉潮。',
    content: `<p>近日，某当红偶像男团成员被狗仔拍到与一名圈外女子在商场约会，两人举止亲密，牵手、拥抱、共饮一杯奶茶，俨然一对热恋中的情侣。</p>
    <p>照片曝光后，该成员的粉丝群体反应激烈。多个粉丝后援会联合发布声明，宣布"集体脱粉"，并关闭了应援站和集资渠道。声明中写道："我们花钱捧你，不是让你拿着我们的钱去谈恋爱。"</p>
    <p>值得注意的是，该成员在多次采访和粉丝见面会中，都强调自己"专注事业，没有时间谈恋爱"。其经纪公司也一直以"单身偶像"的人设为其进行市场推广，吸引了大批"女友粉"。</p>
    <p>业内人士分析，偶像恋爱对于其商业价值的影响是巨大的。"粉丝花钱应援本质上是一种情感消费，当他们发现这种情感被'欺骗'时，反噬也会非常猛烈。"</p>
    <p>目前，该成员及其所属经纪公司尚未就此事作出回应。但其社交媒体账号已在24小时内掉粉超过50万。</p>`,
    category: '明星爆料',
    categorySlug: 'mingxing-baoliao',
    image: 'https://readdy.ai/api/search-image?query=A%20couple%20silhouette%20walking%20in%20a%20shopping%20mall%20at%20night%2C%20paparazzi%20style%20long%20lens%20photography%2C%20warm%20mall%20lighting%2C%20candid%20moment%20captured%2C%20entertainment%20gossip%20aesthetic%2C%20slightly%20blurry%20surveillance%20style%20shot&width=800&height=500&seq=article-6-2026&orientation=landscape',
    date: '2026-08-01',
    views: 175600,
    tags: ['恋情曝光', '脱粉', '人设崩塌'],
    author: '黑料编辑部',
    featured: false,
    trending: true,
  },
  {
    id: 7,
    title: '综艺节目恶意剪辑制造矛盾，嘉宾发文怒斥节目组',
    slug: 'zongyi-eyi-jianji-maodun',
    excerpt: '某热门综艺节目被指通过恶意剪辑制造嘉宾之间的矛盾冲突。一位参与录制的嘉宾在社交平台发文怒斥节目组\"断章取义\"，称剪辑后的内容与实际情况严重不符。',
    content: `<p>综艺节目"恶魔剪辑"再度引发争议。一位参与某热门综艺录制的嘉宾今日在社交平台发布长文，直指节目组通过恶意剪辑手法制造嘉宾矛盾，严重歪曲事实。</p>
    <p>该嘉宾在文中指出，节目中呈现的"我与另一位嘉宾针锋相对"的画面，实际上是将不同场景、不同语境下的对话剪辑拼接而成。"我说A的时候他在回应B，但节目组把两个完全不相关的片段拼在一起，制造出我们在争吵的假象。"</p>
    <p>更令人气愤的是，该嘉宾表示节目组还通过后期配音、添加字幕等方式，进一步强化了"矛盾"的叙事。"有一段我在笑的画面，他们配上了'冷笑'的字幕和紧张的音效，完全改变了原意。"</p>
    <p>此事引发广泛讨论。不少业内人士透露，"恶魔剪辑"在综艺行业几乎是公开的秘密。"不制造矛盾哪来的看点？收视率和话题度全靠'撕'。"一位不愿具名的综艺导演如此表示。</p>
    <p>截至目前，该节目组尚未正式回应此事，但已悄然下架了争议期数中的部分片段。</p>`,
    category: '综艺内幕',
    categorySlug: 'zongyi-neimu',
    image: 'https://readdy.ai/api/search-image?query=A%20video%20editing%20suite%20with%20multiple%20monitors%20showing%20timeline%20clips%2C%20dramatic%20red%20and%20dark%20lighting%2C%20scissors%20motif%2C%20manipulation%20theme%2C%20cinematic%20post-production%20atmosphere%2C%20behind%20the%20scenes%20of%20TV%20show%20editing&width=800&height=500&seq=article-7-2026&orientation=landscape',
    date: '2026-07-31',
    views: 89100,
    tags: ['综艺黑幕', '恶意剪辑'],
    author: '黑料编辑部',
    featured: false,
    trending: false,
  },
  {
    id: 8,
    title: '某老戏骨被曝片场辱骂年轻演员，剧组人员集体投诉',
    slug: 'laoxigu-pianchang-ruma',
    excerpt: '某德高望重的老戏骨在拍摄现场被拍到对年轻演员大声辱骂，言辞极为难听。多名剧组工作人员联名向制片方投诉，要求对该演员进行处理。',
    content: `<p>演艺圈"戏骨"人设再度崩塌。近日，一位以"德艺双馨"著称的老牌演员在片场被拍到对年轻演员进行长达10分钟的辱骂，现场视频在业内小范围传播后引发轩然大波。</p>
    <p>据现场工作人员透露，事情的起因仅仅是年轻演员在走位时慢了几秒钟。"老戏骨当场就炸了，指着人家的鼻子骂，什么'你没长脑子吗''你这种人就不配做演员'，声音大得整个片场都能听见。"</p>
    <p>多名目睹事件经过的剧组工作人员向制片方提交了联名投诉信，要求对该老戏骨的行为进行处理。投诉信中写道："我们理解老艺术家对表演有高要求，但这不能成为随意侮辱他人的理由。"</p>
    <p>颇具讽刺意味的是，该老戏骨此前在多个访谈节目中大谈"艺人要有艺德"，"要尊重每一个工作人员"，其塑造的"德高望重"人设与此次事件的巨大反差令业内人士唏嘘不已。</p>
    <p>截至目前，该老戏骨及其经纪团队尚未作出回应。</p>`,
    category: '圈内黑料',
    categorySlug: 'quannei-heiliao',
    image: 'https://readdy.ai/api/search-image?query=A%20tense%20film%20set%20scene%20with%20dramatic%20shadows%2C%20older%20actor%20silhouette%20gesturing%20aggressively%20toward%20younger%20person%2C%20shocked%20bystanders%20in%20background%2C%20cinematic%20warm%20lighting%20with%20harsh%20contrast%2C%20confrontation%20atmosphere%2C%20behind%20the%20scenes%20drama&width=800&height=500&seq=article-8-2026&orientation=landscape',
    date: '2026-07-30',
    views: 134700,
    tags: ['老戏骨', '片场霸凌', '人设崩塌'],
    author: '黑料编辑部',
    featured: false,
    trending: false,
  },
  {
    id: 9,
    title: '某影后疑似婚变，深夜发文\"重新开始\"后秒删',
    slug: 'yinghou-hunbian-shenye-fawen',
    excerpt: '某金鸡奖影后深夜在社交平台发布\"重新开始，各自安好\"的动态后秒删，引发婚变猜测。其丈夫被拍到近日多次出入某高档小区，疑似已分居。',
    content: `<p>娱乐圈又一对"模范夫妻"疑似婚变。某金鸡奖影后今日凌晨2点在社交平台发布了一条动态："八年了，重新开始，各自安好。"配图是一张日出的照片。该动态发布不到5分钟后即被删除，但已被眼尖的网友截图保存。</p>
    <p>随后，有媒体发现该影后的丈夫近期多次被拍到出入某高档小区，而该影后则一直住在两人婚前的住所。两人社交媒体互动也已经中断超过三个月。</p>
    <p>该影后与丈夫结婚八年，育有一子。两人此前一直被视为娱乐圈的"模范夫妻"，多次在公开场合秀恩爱，共同参加综艺节目时也表现得极为甜蜜。</p>
    <p>圈内人士透露，两人感情出现问题早有端倪。"最近一年他们基本没有同框出现过，连孩子的家长会都是轮流去。"</p>
    <p>目前，双方的工作室均未对此事作出回应。但"深夜发文秒删"的行为本身，已足以让外界对这段婚姻的未来产生疑虑。</p>`,
    category: '明星爆料',
    categorySlug: 'mingxing-baoliao',
    image: 'https://readdy.ai/api/search-image?query=A%20lonely%20figure%20silhouette%20looking%20out%20a%20window%20at%20sunrise%2C%20phone%20screen%20glowing%20in%20dark%20room%2C%20melancholic%20atmosphere%2C%20warm%20golden%20morning%20light%20mixing%20with%20dark%20interior%2C%20emotional%20cinematic%20photography%2C%20soft%20romantic%20but%20sad%20mood&width=800&height=500&seq=article-9-2026&orientation=landscape',
    date: '2026-07-29',
    views: 221400,
    tags: ['婚变', '影后', '恋情曝光'],
    author: '黑料编辑部',
    featured: true,
    trending: true,
  },
  {
    id: 10,
    title: '某流量明星学历造假被扒，北电回应\"查无此人\"',
    slug: 'liuliang-mingxing-xueli-zaojia',
    excerpt: '某流量明星一直宣称自己是北京电影学院表演系毕业，但网友查询发现北电校友系统中并无此人。北电官方回应\"经核查，我校毕业生档案中无该生信息\"。',
    content: `<p>娱乐圈"学霸人设"再次翻车。近日，一位拥有数千万粉丝的流量明星被网友扒出学历造假。该明星此前在多个场合声称自己是北京电影学院表演系本科毕业，但经过网友深挖，发现北电校友数据库中根本没有此人的信息。</p>
    <p>事件发酵后，北京电影学院官方发布声明回应："经核查，我校历届毕业生档案中无该人员信息。"这一官方回应直接坐实了该明星学历造假的质疑。</p>
    <p>更令人震惊的是，该明星不仅造假了学历，其"艺考第一名"、"在校期间多次获得奖学金"等说法也全部被证伪。有网友调出了当年的艺考成绩单，前30名中根本没有他的身影。</p>
    <p>该明星此前凭借"科班出身"的人设，获得了多个需要专业背景的影视项目。学历造假曝光后，多个剧组宣布与其解约，品牌代言也纷纷下架相关广告物料。</p>
    <p>业内人士表示，学历造假在娱乐圈并不罕见，但如此明目张胆地编造"北电科班"背景并被官方直接打脸的情况，还是相当罕见的。</p>`,
    category: '最新丑闻',
    categorySlug: 'zuixin-chouwen',
    image: 'https://readdy.ai/api/search-image?query=A%20close-up%20of%20a%20fake%20diploma%20with%20red%20fraud%20stamp%20on%20dark%20desk%2C%20dramatic%20crimson%20and%20black%20lighting%2C%20investigative%20journalism%20style%2C%20academic%20fraud%20theme%2C%20mysterious%20shadows%2C%20cinematic%20noir%20aesthetic&width=800&height=500&seq=article-10-2026&orientation=landscape',
    date: '2026-07-28',
    views: 198300,
    tags: ['学历造假', '人设崩塌', '流量明星'],
    author: '黑料编辑部',
    featured: false,
    trending: true,
  },
  {
    id: 11,
    title: '某知名主持人被曝收受粉丝天价礼物，总价值超千万',
    slug: 'zhuchi-ren-shou-liwu',
    excerpt: '某当红主持人被曝长期收受粉丝后援会赠送的天价礼物，包括奢侈品牌包袋、高端电子产品等，累计价值超过千万元。网友质疑其存在变相受贿嫌疑。',
    content: `<p>粉丝应援乱象再度引发关注。近日，一份据称是某当红主持人粉丝后援会的"应援清单"在网上流传，清单详细记录了近三年来该主持人收受的粉丝礼物，总价值超过1000万元。</p>
    <p>根据清单显示，这些礼物包括多只爱马仕、香奈儿等奢侈品牌手袋（单价在10万-50万不等）、最新款iPhone和MacBook、高档护肤礼盒、甚至还有金条。每逢该主持人生日、节目开播、跨年等重要节点，粉丝后援会都会组织大规模送礼活动。</p>
    <p>法律专家指出，公职人员收受礼品有明确金额限制，而主持人虽然不是严格意义上的公职人员，但如果利用职务影响力收受贵重礼物，同样可能涉及不当得利甚至是受贿的问题。</p>
    <p>事件曝光后，多家媒体发表评论文章，呼吁规范粉丝应援行为。"当'爱的表达'变成了赤裸裸的金钱交易，这种畸形的粉丝文化已经到了必须整治的时候。"</p>
    <p>该主持人所在电视台表示，已启动内部调查程序。该主持人本人则通过工作室发声称"对礼物金额并不知情，将配合调查"。</p>`,
    category: '圈内黑料',
    categorySlug: 'quannei-heiliao',
    image: 'https://readdy.ai/api/search-image?query=A%20pile%20of%20luxury%20gift%20boxes%20with%20designer%20brand%20logos%20stacked%20on%20a%20dark%20table%2C%20dramatic%20golden%20and%20crimson%20lighting%2C%20investigative%20expose%20style%2C%20consumerism%20and%20corruption%20theme%2C%20cinematic%20photography&width=800&height=500&seq=article-11-2026&orientation=landscape',
    date: '2026-07-27',
    views: 87600,
    tags: ['粉丝应援', '圈内黑料', '受贿'],
    author: '黑料编辑部',
    featured: false,
    trending: false,
  },
  {
    id: 12,
    title: '某歌手被前经纪人爆料吸毒史，曾多次在后台\"溜冰\"',
    slug: 'geshou-qianjingjiren-baoliao',
    excerpt: '某知名歌手的前经纪人公开发文爆料，揭露该歌手长达数年的吸毒史，称其多次在演唱会后台吸食冰毒。爆料人提供了详细的聊天记录和转账记录作为证据。',
    content: `<p>娱乐圈涉毒丑闻再次震惊公众。今日，某知名歌手的前经纪人在社交平台发布长文，详细揭露了该歌手长达五年的吸毒史。</p>
    <p>据前经纪人爆料，该歌手从2021年开始接触毒品，最初是在朋友聚会上尝试大麻，后逐渐升级为冰毒。"他（她）每次演出前都要'溜冰'（吸食冰毒），说这样状态好。我在后台亲眼见过很多次，整个化妆间都是那种味道。"</p>
    <p>爆料人同时公布了多段聊天记录和银行转账记录作为证据。记录显示，该歌手曾多次向前经纪人转账，要求其"帮忙搞点东西"，金额从数千元到数万元不等。</p>
    <p>该前经纪人表示，自己选择现在爆料是因为"良心发现了"。"看着他（她）一步步毁掉自己，我不能再沉默了。希望他（她）能去戒毒。"</p>
    <p>此消息一经发布，立即引发全网关注。多地禁毒部门表示已关注到相关爆料，正在核实情况。该歌手的经纪公司尚未对此作出回应，但其即将举行的巡回演唱会已被多地场馆取消预订。</p>`,
    category: '最新丑闻',
    categorySlug: 'zuixin-chouwen',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20backstage%20area%20with%20scattered%20items%20on%20a%20dressing%20table%2C%20dramatic%20red%20and%20black%20lighting%2C%20ominous%20atmosphere%2C%20mirror%20reflection%2C%20concert%20backstage%20aesthetic%2C%20dark%20secret%20theme%2C%20cinematic%20noir%20style&width=800&height=500&seq=article-12-2026&orientation=landscape',
    date: '2026-07-26',
    views: 345800,
    tags: ['吸毒', '前经纪人', '爆料'],
    author: '黑料编辑部',
    featured: true,
    trending: true,
  },
];